import appPrivateBusRequests from "../../views/appSettings/privatebusrequests.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "private-bus-requests";
  const params = [
    "page",
    "limit",
    "inbound_trip_date",
    "from_city",
    "to_city",
    "status",
    "is_round_trip",
  ];

  $stateProvider.state("privatebusrequests", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appPrivateBusRequests,
      },
    },
    reloadOnSearch: false,
    data: { title: "PrivateBusRequests" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/privateBusRequests/privateBusRequests.urls.js